import { createContext } from 'react';

const fixedAssetContext = createContext();

export default fixedAssetContext;
